import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/contacto/reunion")({
  head: () => ({
    meta: [
      { title: "Agendar reunión | Mine Class" },
      { name: "description", content: "Reserva un horario con nuestro equipo B2B en Google Calendar." },
      { property: "og:title", content: "Agendar reunión | Mine Class" },
      { property: "og:description", content: "Reserva un horario con el equipo B2B de Mine Class y coordina una reunión por Google Calendar." },
      { property: "og:url", content: "https://mine-class.com/contacto/reunion" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/contacto/reunion" }],
  }),
  component: ReunionPage,
});

function ReunionPage() {
  return (
    <section id="agendar" className="not-prose" aria-labelledby="reunion-titulo">
      <div className="text-center mb-8">
        <div className="text-xs uppercase tracking-widest text-[var(--color-brand-coral)] font-bold mb-2">Agenda una reunión</div>
        <h2 id="reunion-titulo" className="text-headline-lg text-[var(--color-brand-purple)]">Reserva un horario con nuestro equipo</h2>
        <p id="reunion-desc" className="text-sm text-[var(--color-on-surface-variant)] mt-2">
          Selecciona un día y horario disponible en el calendario de ventas.
        </p>
      </div>

      <iframe
        src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3tvpaCcyI09JXiLvq8UXk9_i36LoEJd5YeZjr8lmk2HbwynysRR55KD2uwK7nqn-vDDoR6BCqR?gv=true"
        title="Agendar reunión con ventas de Mine Class"
        aria-label="Calendario interactivo para agendar una reunión con el equipo de ventas de Mine Class"
        aria-describedby="reunion-desc"
        role="region"
        className="block w-full border-0 p-0 m-0"
        style={{ border: 0 }}
        width="100%"
        height="600"
        frameBorder={0}
        loading="lazy"
      ></iframe>
    </section>
  );
}
